module.exports = __webpack_public_path__ + "img/0.da768ec4.png";